import React, { useState, useEffect } from 'react';
import './InPrincipalView.css';
import logo from '../../../images/icons/FincityLogoDashboard.svg';
import house from '../../../images/icons/house.svg';
import bill from '../../../images/icons/bill.svg';
import personalDiscussion from '../../../images/icons/personal-discussion.svg';
import techCheck from '../../../images/icons/tech-check.svg';
import {
  getInPrincipleSanction,
  sendInPrincipalEmail
} from '../../../common/constants/api';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
import PopUp from '../../../common/components/PopUp/PopUp';
import { numberFormat } from '../../../common/constants/NumberFormat';
import moment from 'moment';
import { getUserType } from '../../../common/utils/cookie-utils';
function InPrincipalView() {
  const [apiData, setApiData] = useState('');
  const [show, setShow] = useState(false);
  const [emailSend, setEmailSend] = useState(false);
  const [userType, setUserType] = useState(getUserType());
  let colors = ['#e8fdff', '#eaecf9', '#fff0f8', '#fffadd'];
  const [inPrincipalRes, setInPrincipalRes] = useState({
    isFetching: false,
    isFetched: false,
    isFailure: false,
    data: {
      status: '',
      message: ''
    }
  });
  const { isFetched, isFailure, isFetching, data } = inPrincipalRes;
  useEffect(() => {
    let applicant = getApplicantionInfo();
    setInPrincipalRes({ ...inPrincipalRes, isFetching: true });
    setShow(true);
    getInPrincipleSanction(applicant.leadId)
      .then(res => {
        setInPrincipalRes({
          ...inPrincipalRes,
          isFetching: false,
          isFetched: false
        });
        setApiData(res);
        setShow(false);
      })
      .catch(err => {
        setInPrincipalRes({
          ...inPrincipalRes,
          isFetching: false,
          isFetched: false,
          data: {
            status: err?.response?.data?.status,
            message:
              err?.response?.data?.status !== 500
                ? err?.response?.data?.message
                : 'Something went wrong!'
          }
        });
      });
  }, []);
  let sendEmailToCustomer = () => {
    let applicant = getApplicantionInfo();
    setInPrincipalRes({ ...inPrincipalRes, isFetching: true });
    setShow(true);
    sendInPrincipalEmail(applicant.leadId)
      .then(() => {
        setInPrincipalRes({
          ...inPrincipalRes,
          isFetching: false,
          isFetched: true
        });
        setEmailSend(true);
      })
      .catch(err => {
        setInPrincipalRes({
          ...inPrincipalRes,
          isFetching: false,
          isFetched: false,
          data: {
            status: err?.response?.data?.status,
            message:
              err?.response?.data?.status !== 500
                ? err?.response?.data?.mesaage
                : 'Something went wrong!'
          }
        });
      });
  };
  return (
    <React.Fragment>
      {!data?.message ? (
        <div className="w-full">
          <div className="w-full md:w-9/12 mt-8 bg:white relative m-auto bg-white shadow-lg rounded-lg mb-8 pb-16">
            <div className="flex">
              <div className="float-left md:w-6/12 p-8">
                <img src={logo} alt="Logo" />
              </div>
              {apiData?.emailCustomer && userType != 2 ? (
                <div className="float-left md:w-6/12">
                  <div
                    onClick={sendEmailToCustomer}
                    className="w-48 h-10 py-3 mt-8 mr-4 cursor-pointer text-center text-white bg-tealCol-100 rounded-md float-right hover:bg-teal"
                  >
                    {emailSend
                      ? 'Resend  Email to Customer'
                      : 'Send Email to Customer'}
                  </div>
                </div>
              ) : null}
            </div>
            <div className="flex items-center justify-center">
              <span>
                <img src={house} alt="congratulations" />
              </span>
              <span className="font-roboto text-3xl px-2 mt-2 text-black-400">
                Congratulations!
              </span>
            </div>
            <div className="flex items-center justify-center">
              <span className="font-roboto px-8 py-1 text-xl mt-4 text-black-400 bg-grey-1100 rounded-sm">
                In-Principal indication
              </span>
            </div>
            <div className="p-8 overflow-hidden">
              <div className="w-full float-left md:w-7/12">
                <div className="w-full font-roboto font-md text-black-400 py-1">
                  <span>Applicant : </span>
                  <span className="font-semibold">
                    {apiData?.leadDetails?.mainApplicant?.name?.firstName}&nbsp;
                    {apiData?.leadDetails?.mainApplicant?.name?.middleName}
                    &nbsp;
                    {apiData?.leadDetails?.mainApplicant?.name?.lastName}
                  </span>
                </div>
                {apiData?.leadDetails?.coApplicants?.map((item, i) => {
                  return (
                    <div className="w-full font-roboto font-md text-black-400 py-1">
                      <span>Co-Applicant {i + 1} : </span>
                      <span className="font-semibold">
                        {item?.name?.firstName}&nbsp;{item?.name?.lastName}
                      </span>
                    </div>
                  );
                })}
              </div>
              <div className="w-full float-left md:w-5/12 flex-row justify-end">
                <div className="font-roboto font-md text-black-400 py-1">
                  <span>Indication ID : </span>
                  <span className="font-semibold">{apiData?.id || 'NA'}</span>
                </div>
                <div className="font-roboto font-md text-black-400 py-1">
                  <span>Indication Date : </span>
                  <span className="font-semibold">
                    {moment(apiData?.createdDate).format('Do MMM YYYY')}
                  </span>
                </div>
              </div>
            </div>
            <div className="w-full md:w-8/12 px-8 tableview text-sm">
              <table>
                {apiData?.bankName !== null &&
                apiData?.bankName !== 'Anonymous' ? (
                  <tr>
                    <td>Bank Name</td>
                    <td>{apiData?.bankName || 'NA'}</td>
                  </tr>
                ) : null}
                <tr>
                  <td>Nature of facility</td>
                  <td>{apiData?.leadDetails?.loanSubProduct || 'NA'}</td>
                </tr>
                <tr>
                  <td>Purpose of Loan</td>
                  <td>{apiData?.leadDetails?.loanProduct || 'NA'}</td>
                </tr>
                <tr>
                  <td>Type of Property</td>
                  <td>{apiData?.leadDetails?.propertyType || 'NA'}</td>
                </tr>
                <tr>
                  <td>Requested Loan Amount</td>
                  <td>₹ {numberFormat(apiData?.loanAmount) || 'NA'}</td>
                </tr>
                <tr>
                  <td>Sanction Amount</td>
                  <td>₹ {numberFormat(apiData?.sanctionAmount) || 'NA'}</td>
                </tr>
                <tr>
                  <td>Interest Rate Type</td>
                  <td>{apiData?.interestRateType || 'NA'}</td>
                </tr>
                <tr>
                  <td>Base Rate(%)</td>
                  <td>{apiData?.baseRate || 'NA'}</td>
                </tr>
                <tr>
                  <td>Rate of Interest(%)</td>
                  <td>
                    {apiData?.roi || 'NA'}{' '}
                    <span className="text-xs ml-1">
                      (Base Rate &plusmn;&nbsp;
                      {parseFloat(apiData?.roi - apiData?.baseRate).toFixed(2)}
                      %) )
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>Loan Tenure</td>
                  <td> {parseInt(apiData?.loanTenureInMonths) || 'NA'}</td>
                </tr>
                <tr>
                  <td>Processing Charges</td>
                  <td>
                    ₹ {numberFormat(apiData?.totalProcessingCharges) || 'NA'}{' '}
                    <span className="text-xs ml-1">(Inclusive of GST)</span>
                  </td>
                </tr>
                <tr>
                  <td>Additional Charge</td>
                  <td>₹ {numberFormat(apiData?.additionalCharges) || 'NA'}</td>
                </tr>
                <tr>
                  <td>Valid upto</td>
                  <td>
                    {apiData?.validUpto || 'NA'} Days
                    <span className="text-xs ml-1">
                      (From the date of this communication)
                    </span>
                  </td>
                </tr>
              </table>
            </div>
            {apiData?.loanOffers?.length > 0 ? (
              <div className="w-full p-8 lg:flex">
                <div className="flex-row offer_box w-full md:w-2/12 text-green-500 text-right p-2 hidden lg:block">
                  <span className="block p-1 px-2 h-17"></span>
                  <span className="block p-1 px-2">Interest Rate</span>
                  <span className="block p-1 px-2">Monthly EMI</span>
                  <span className="block p-1 px-2">Loan Amount</span>
                </div>
                {apiData?.loanOffers?.map((item, i) => {
                  return (
                    <div className="w-full lg:w-2/12 m-2">
                      {item?.offerName.trim() ==
                      'Both Life and Property Insurance' ? (
                        <span className="bg-green-800 text-white p-1 rounded fincity-recomdations">
                          Fincity Recommendation
                        </span>
                      ) : (
                        <span className="bg-green-800 text-white p-1 rounded fincity-recomdations invisible"></span>
                      )}
                      <div
                        className=" flex-row offer_box w-full "
                        key={`laon-item${i}`}
                        style={{ background: colors[i] }}
                      >
                        <span className="block p-1 px-2 h-12">
                          {item?.offerName || 'NA'}
                        </span>
                        <span className="block p-1 px-2">
                          {item?.roi || 'NA '}% pa
                        </span>
                        <span className="block p-1 px-2">
                          ₹ {numberFormat(item?.emi) || 'NA'}
                        </span>
                        <span className="block p-1 px-2">
                          ₹
                          {numberFormat(
                            item?.additionalAmount + apiData.sanctionAmount
                          ) || 'NA'}
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : null}
            <div className="px-8 py-2 text-xs text-black-400">
              This is an in-principal sanction and the final decision of
              disbursal will be a sole decision of the bank and subject to (but
              not limited to) the fulfilment of the following conditions
            </div>
            <div className="flex px-8 py-2 text-xs text-black-400">
              <span className="px-1">
                <img src={techCheck} alt="Tech check" />
              </span>
              <span className="py-1">Legal and Technical check</span>
            </div>
            <div className="flex px-8 py-2 text-xs text-black-400">
              <span className="px-1">
                <img src={personalDiscussion} alt="Tech check" />
              </span>
              <span className="py-1">Personal discussion by credit team</span>
            </div>
            <div className="flex px-8 py-2 text-xs text-black-400">
              <span className="px-1">
                <img src={bill} alt="Tech check" />
              </span>
              <span className="py-1">
                Any other condition as deemed necessary by the Bank
              </span>
            </div>
            {apiData?.termsAndCondition?.length > 0 ? (
              <div className="px-8 py-2 text-xs text-black-400">
                <div className="w-full font-semibold">
                  Additional Conditions
                </div>
                <div>
                  {apiData?.termsAndCondition?.map((item, i) => {
                    return <li>{item}</li>;
                  })}
                </div>
              </div>
            ) : null}
          </div>
        </div>
      ) : null}
      <PopUp
        goto={data?.status == 403}
        dontClose={!data?.status == 400}
        type={data?.message ? 'fail' : isFetched ? 'success' : 'loading'}
        text={
          isFetching
            ? 'Loading . . .'
            : isFetched
            ? 'Email has been sent successfully!'
            : data?.message
        }
        show={show}
        setShow={setShow}
        autoClose={data?.status == 400}
      />
    </React.Fragment>
  );
}
export default InPrincipalView;
